const getters = {
  getListBusinessAccount: state => state.listBusinessAccount,
  getEmployerInfoDetail: state => state.employerDetail,
  getListConnectionCommentEmployer: state => state.listConnectionCommentEmployer,
  getListEducationTrainingEmployer: state => state.listEducationTrainingEmployer,
  getListNoticeBoardEmployer: state => state.listNoticeBoardEmployer,
  getListProudOfEmployer: state => state.listProudOfEmployer,
  getListWorkingPortfolioEmployer: state => state.listWorkingPortfolioEmployer,
  getListHistoryEmployer: state => state.listHistoryEmployer,
  getTotalHistoryEmployer: state => state.totalHistoryEmployer,
  getListHistoryEmployerAdded: state => state.listHistoryEmployerAdded,
  getTotalHistoryEmployerAdded: state => state.totalHistoryEmployerAdded,
  getListEmploymentHistoryEmployer: state => state.listEmploymentHistoryEmployer,
  getTalentInfoDetail: state => state.talentDetail,
  getListConnectionComment: state => state.listConnectionComment,
  getListEducationTraining: state => state.listEducationTraining,
  getListNoticeBoard: state => state.listNoticeBoard,
  getListProudOf: state => state.listProudOf,
  getListWorkingPortfolio: state => state.listWorkingPortfolio,
  getListWorkingHistory: state => state.listWorkingHistory,
  getTotalWorkingHistory: state => state.totalWorkingHistory,
  getListHistoryTalentAdded: state => state.listHistoryTalentAdded,
  getTotalHistoryTalentAdded: state => state.totalHistoryTalentAdded,
  getAllowBackPage: state => state.allowBackPage,
  getListJobsToMakeOffer: state => state.listJobsToMakeOffer
}

export default getters
